import { PRODUCT_IDS, STATUS_CONFIG } from "./constants";

export const formatMoney = (value) => `$${Number(value ?? 0).toFixed(2)}`;

export const getStatusConfig = (status) =>
  STATUS_CONFIG[status] || { label: status, color: "default" };

// Arma el arreglo de items que espera create_preorder.php a partir de las
// dos cantidades del formulario, descartando las que quedaron en 0.
export const buildOrderItems = (panuchos, salbutes) =>
  [
    { product_id: PRODUCT_IDS.PANUCHOS, quantity: Number(panuchos || 0) },
    { product_id: PRODUCT_IDS.SALBUTES, quantity: Number(salbutes || 0) },
  ].filter((item) => item.quantity > 0);
